import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useRef, useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { useAssessment } from "../components/assessmentContext";
import  en  from "../json/en.json";
import  ch  from "../json/ch.json";

export default function Navbar({ userInitial, onSignOut }) {
   const lId =
    localStorage.getItem("languageId") || "1";

  const [logOffContainer, setLogOffContainer] = useState(false);
  const logOffRef = useRef(null);
  const userInitialRef = useRef(null);
  const { activeAssessment, setActiveAssessment } = useAssessment();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isAssessmentDropdownOpen, setAssessmentDropdownOpen] = useState(false);

  const location = useLocation();

  const assessmentMap = {
    0: { label: lId==="1"?en.selfAssessment:ch.selfAssessment, id: 1 },
    1: { label: lId==="1"?en.reviewAssessment:ch.reviewAssessment, id: 2 },
    2: { label: lId==="1"?en.finalEvaluation:ch.finalEvaluation, id: 3 },
  };

  const selectedAssessment = assessmentMap[activeAssessment];
  localStorage.setItem("AssessmentText", selectedAssessment?.label || ""); // Default to Self Assessment
  console.log("selectedAssessment", selectedAssessment);

  useEffect(() => {
    localStorage.setItem("AssessmentId", 1);
    if (activeAssessment === null || activeAssessment === undefined) {
      setActiveAssessment(0); // Default to Self Assessment
    }
  }, []);

  const handleAssessmentSelect = (assessmentIndex) => {
    setActiveAssessment(assessmentIndex);

    const assessmentId = assessmentIndex + 1; // 0 => 1, 1 => 2, 2 => 3
    // Optionally, you can save or use assessmentId here
    console.log("Selected Assessment ID:", assessmentId);
    localStorage.setItem("AssessmentId", assessmentId);
  };

  const isQuestionnairePath =
    location.pathname.startsWith("/questionnaires") ||
    location.pathname.startsWith("/question");

  // handle log off
  const handleLogOff = () => {
    setLogOffContainer((prevState) => !prevState); // Toggle log-off-hover visibility
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    setAssessmentDropdownOpen(false); // Close dropdown when menu toggles
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setAssessmentDropdownOpen(false);
  };

  return (
    <>
      <div className="navbar-wrapper">
        <div className="navbar">
          <div className="logo-section">
            <Link to="/">
              <img src="/assets/main/logo.png" alt="" />
            </Link>
          </div>
          <div className="list-section">
            <ul className="list-none">
              <li>
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    `pb-2 ${
                      isActive
                        ? "border-b-[3px] border-[#f40009] text-black"
                        : "border-b-[3px] border-transparent text-gray-700 hover:border-gray-300"
                    }`
                  }
                  style={{ fontFamily: "TCCC-UnityTextPC-Bold" }}
                >
                  {lId==="1"?en.home:ch.home}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/questionnaires"
                  className={`pb-2 border-b-[3px] ${
                    isQuestionnairePath
                      ? "border-[#f40009] text-black"
                      : "border-transparent text-gray-700 hover:border-gray-300"
                  }`}
                  style={{ fontFamily: "TCCC-UnityTextPC-Bold" }}
                >
                   {lId==="1"?en.questionnaire:ch.questionnaire}
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/results"
                  className={({ isActive }) =>
                    `pb-2 ${
                      isActive
                        ? "border-b-[3px] border-[#f40009] text-black"
                        : "border-b-[3px] border-transparent text-gray-700 hover:border-gray-300"
                    }`
                  }
                  style={{ fontFamily: "TCCC-UnityTextPC-Bold" }}
                >
                  {lId==="1"?en.results:ch.results}
                </NavLink>
              </li>
              <Menu as="li" className="relative inline-block text-left">
                <div>
                  <MenuButton
                    style={{ fontFamily: "TCCC-UnityTextPC-Bold" }}
                    className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white font-semibold text-gray-900"
                  >
                    {selectedAssessment?.label}
                    <ChevronDownIcon
                      aria-hidden="true"
                      className="mr-1 size-8 text-black"
                      style={{ strokeWidth: "6", marginTop: "0.5rem" }}
                    />
                  </MenuButton>
                </div>

                <MenuItems
                  transition
                  className="absolute left-[2.2rem] z-10 mt-4 whitespace-nowrap w-auto min-w-fit origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                  <div className="flex flex-col items-center">
                    <MenuItem>
                      <button
                        onClick={() => handleAssessmentSelect(0)}
                        className={`block p-4 w-full text-[1.6rem] text-left ${
                          activeAssessment === 0
                            ? "text-[#f40009]"
                            : "text-gray-700 hover:bg-gray-200"
                        }`}
                        style={{ fontFamily: "TCCC-UnityTextPC-Bold" }}
                      >
                        {lId==="1"?en.selfAssessment:ch.selfAssessment}
                      </button>
                    </MenuItem>

                    <MenuItem>
                      <button
                        onClick={() => handleAssessmentSelect(1)}
                        className={`block p-4 w-full text-[1.6rem] text-left ${
                          activeAssessment === 1
                            ? "text-[#f40009]"
                            : "text-gray-700 hover:bg-gray-200"
                        }`}
                        style={{ fontFamily: "TCCC-UnityTextPC-Bold" }}
                      >
                        {lId==="1"?en.reviewAssessment:ch.reviewAssessment}
                      </button>
                    </MenuItem>

                    <MenuItem>
                      <button
                        onClick={() => handleAssessmentSelect(2)}
                        className={`block p-4 w-full text-[1.6rem] text-left ${
                          activeAssessment === 2
                            ? "text-[#f40009]"
                            : "text-gray-700 hover:bg-gray-200"
                        }`}
                        style={{ fontFamily: "TCCC-UnityTextPC-Bold" }}
                      >
                        {lId==="1"?en.finalEvaluation:ch.finalEvaluation}
                      </button>
                    </MenuItem>
                  </div>
                </MenuItems>
              </Menu>
            </ul>
          </div>
          <div className="log-off">
            <div
              className="user-initial"
              onClick={handleLogOff}
              ref={userInitialRef}
            >
              <p>{userInitial}</p>
            </div>

            {logOffContainer && (
              <div className="log-off-hover shadow-md" ref={logOffRef}>
                <div className="log-out" onClick={() => onSignOut()}>
                  <h2>{lId==="1"?en.logOut:ch.logOut}</h2>
                  <img src="/assets/landingPage/sign-out.png" alt="Sign Out" />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="mobile-navbar-wrapper">
        <div className="mobile-navbar">
          <div className="mobile-logo-section">
            <Link to="/">
              <img src="/assets/main/logo.png" alt="" />
            </Link>
          </div>

          <div className="mobile-menu-toggle" onClick={toggleMobileMenu}>
            <div className={`hamburger ${isMobileMenuOpen ? "open" : ""}`}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>

          <div
            className={`mobile-menu-panel ${isMobileMenuOpen ? "open" : ""}`}
          >
            <div className="mobile-menu-content">
              <NavLink
                to="/"
                className={({ isActive }) =>
                  `mobile-nav-item ${isActive ? "active" : ""}`
                }
                onClick={closeMobileMenu}
              >
                {lId==="1"?en.home:ch.home}
              </NavLink>

              <NavLink
                to="/questionnaires"
                className={`mobile-nav-item ${
                  isQuestionnairePath ? "active" : ""
                }`}
                onClick={closeMobileMenu}
              >
                {lId==="1"?en.questionnaire:ch.questionnaire}
              </NavLink>

              <NavLink
                to="/results"
                className={({ isActive }) =>
                  `mobile-nav-item ${isActive ? "active" : ""}`
                }
                onClick={closeMobileMenu}
              >
                {lId==="1"?en.results:ch.results}
              </NavLink>

              <div className="mobile-assessment-dropdown">
                <div
                  className="mobile-dropdown-header"
                  onClick={() =>
                    setAssessmentDropdownOpen(!isAssessmentDropdownOpen)
                  }
                >
                  <span>{selectedAssessment?.label}</span>
                  <ChevronDownIcon
                    className={`dropdown-icon ${
                      isAssessmentDropdownOpen ? "open" : ""
                    }`}
                  />
                </div>

                {isAssessmentDropdownOpen && (
                  <div className="mobile-dropdown-options">
                    <button
                      onClick={() => {
                        handleAssessmentSelect(0);
                        setAssessmentDropdownOpen(false);
                      }}
                      className={`mobile-dropdown-option ${
                        activeAssessment === 0 ? "active" : ""
                      }`}
                    >
                      {lId==="1"?en.selfAssessment:ch.selfAssessment}
                    </button>

                    <button
                      onClick={() => {
                        handleAssessmentSelect(1);
                        setAssessmentDropdownOpen(false);
                      }}
                      className={`mobile-dropdown-option ${
                        activeAssessment === 1 ? "active" : ""
                      }`}
                    >
                      {lId==="1"?en.reviewAssessment:ch.reviewAssessment}
                    </button>

                    <button
                      onClick={() => {
                        handleAssessmentSelect(2);
                        setAssessmentDropdownOpen(false);
                      }}
                      className={`mobile-dropdown-option ${
                        activeAssessment === 2 ? "active" : ""
                      }`}
                    >
                     {lId==="1"?en.finalEvaluation:ch.finalEvaluation}
                    </button>
                  </div>
                )}
              </div>

              <div className="mobile-logout-container">
                <div
                  className="mobile-logout"
                  onClick={() => {
                    onSignOut();
                    closeMobileMenu();
                  }}
                >
                  <span>{lId==="1"?en.logOut:ch.logOut}</span>
                  <img src="/assets/landingPage/sign-out.png" alt="Sign Out" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
